import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogContent,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    DialogTitle,
    Box,
    DialogActions
} from '@mui/material';
import './boundCases.css';
import axios from "axios";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import {useLocation} from "react-router-dom";
import CaseDocumentInternalFlowStatusEnum from "../../enums/CaseDocumentInternalFlowStatusEnum";

function ChangeCaseUserPopup({
                                 open,
                                 handleClose,
                                 users,
                                 caseManager,
                                 onUpdate,
                                 caseManagers,
                                 caseFiles,
                                 onFileUpdate,
                                 departmentId,
                                 internalFileToEditManager = null,
                                 isInternalFlowPopup = false,
                                 addNewCaseUser
                             }) {
    const [selectedUser, setSelectedUser] = useState('');
    const [userModalOpen, setUserModalOpen] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const filesToUpdate = caseFiles.filter(file => file.creatorId === caseManager.toUserId)
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');

    const sendNotification = async (newUserID) => {

        const caseNotification = {
            nextStepUserId: newUserID,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.addUser.id,
            caseStatus: 8,
            viewed: false,
            newUserID: newUserID,
            oldUserID: caseManager.toUserId

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const sendNotificationForExistingExpert = async (newUserID) => {

        const caseNotification = {
            nextStepUserId: newUserID,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.added.id,
            caseStatus: 8,
            viewed: false,
        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const editInternalFile = async () => {
        const fileData = {
            ...internalFileToEditManager,
            answerStatus: CaseDocumentInternalFlowStatusEnum.Resolved

        };
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, fileData);
    };

    useEffect(() => {
        if (isInternalFlowPopup) {
            const filtered = users.filter(user => user.departmentId === departmentId);
            setSelectedUser(caseManager.toUserId);
            setFilteredUsers(filtered);
        } else {
            const filtered = users.filter(user => !caseManagers.some(cm => cm.toUserId === user.id) && user.departmentId === departmentId);
            setFilteredUsers(filtered);
        }

    }, [users, caseManagers]);

    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };


    const updateCaseViewer = async () => {

            const managerRole = users.find(role => role.id === caseManager.toUserId)

            if (!managerRole) {
                alert("დაფიქსირდა შეცდომა");
                return;
            }


            if (isInternalFlowPopup && caseManager.toUserId === selectedUser) {
                await sendNotificationForExistingExpert(selectedUser)
                if (isInternalFlowPopup && internalFileToEditManager) {
                    await editInternalFile();
                }
                onFileUpdate();
                setUserModalOpen(false);
                setSelectedUser("");
                handleClose();
                onUpdate();
                return
            }
            if (isInternalFlowPopup && managerRole.roleName !== "Expert") {
                await addNewCaseUser(selectedUser, caseId);
                await sendNotification(selectedUser)
                if (isInternalFlowPopup && internalFileToEditManager) {
                    await editInternalFile();
                }
                onFileUpdate();
                setUserModalOpen(false);
                setSelectedUser("");
                handleClose();
                onUpdate();
                return
            }

            const body = {
                ...caseManager,
                toUserId: selectedUser
            };
            try {
                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseUserAllProperty`, body);
            } catch (error) {
                console.error(error);
            }

            if (filesToUpdate.length > 0) {
                const updatePayload = {
                    casefileIds: filesToUpdate.map(file => file.id),
                    caseCreatorId: selectedUser
                };
                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseFileCreatorId`, updatePayload);
            }
            onUpdate();
            await sendNotification(selectedUser)
            if (isInternalFlowPopup && internalFileToEditManager) {
                await editInternalFile();
            }
            onFileUpdate();
            setUserModalOpen(false);
            setSelectedUser("");
            handleClose();
        }
    ;

    const handleUserChange = (event) => {
        setSelectedUser(event.target.value);
    };

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={open}
                onClose={handleClose}
                aria-labelledby="change-case-user-dialog-title"
                PaperProps={{
                    style: {
                        borderRadius: '10px',
                        padding: '20px',
                        position: 'relative',
                    }
                }}
            >
                <DialogTitle id="change-case-user-dialog-title">შემსრუელბის შეცვლა</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="user-select-label">შემსრულებელი</InputLabel>
                        <Select
                            labelId="user-select-label"
                            value={selectedUser}
                            label="შემსრულებელი"
                            onChange={handleUserChange}
                        >
                            {filteredUsers.map((user) => (
                                <MenuItem key={user.id} value={user.id}>
                                    {user.firstName} {user.lastName} ({rolesInGeorgian[user.roleName]})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            გაუქმება
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setUserModalOpen(true)}
                            disabled={!selectedUser}
                        >
                            დადასტურება
                        </Button>
                    </Box>
                </DialogActions>
                {userModalOpen && (
                    <ConfirmationModal
                        isOpen={userModalOpen}
                        onRequestClose={() => setUserModalOpen(false)}
                        onConfirm={() => {
                            void updateCaseViewer();
                        }}
                    />)}
            </Dialog>
        </>
    );
}

export default ChangeCaseUserPopup;
